<template>
  <div class="player-control" @click="handleAction">
    <div v-if="isPlaying" class="player-control__button" tabindex="0">
      <sh-icon class="player-control__pause" name="pause" :size="iconSize"/>
    </div>
    <div v-else class="player-control__button" tabindex="0">
      <sh-icon class="player-control__play" name="play" :size="iconSize"/>
    </div>
  </div>
</template>

<script>
import { ShIcon } from '@sohohouse/design-system'

export default {
  name: 'PlayPauseControl',
  components: {
    ShIcon
  },
  props: {
    isPlaying: {
      type: Boolean,
      require: true
    }
  },
  computed: {
    iconSize () {
      return this.$device.isMobile ? 'small' : 'medium'
    }
  },
  methods: {
    handleAction () {
      this.$emit('handleAction')
    }
  }
}
</script>

<style lang="scss" scoped>
.player-control {
  margin-right: $space-040;
  margin-left: $space-030;
  cursor: pointer;

  @include tablet {
    margin-right: $space-050;
  }
}
</style>
